import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from "react-router-dom";
import axios from 'axios';

//Redux Imports
import { Provider } from "react-redux";
import { useDispatch, useSelector } from 'react-redux';

//Components 
import AuthRoute from "./AuthRoute";// higher-order component (HOC) to wrap the <Router /> component
import store from "components/store";// Importing the store.

//PAGES 
import LoginPage from "layouts/Login.js";
import LandingApps from "layouts/LandingApps.js";
// import Schematics from "spatial-view/Diagram.js";
import Support from "layouts/SupportRole";
import Accounting from "layouts/AccountsRole";
import SalesOpeartor from "layouts/SalesOperatorRole";
import SalesAdmin from "layouts/SalesAdminRole";
import DealerAdminRole from "layouts/DealerAdminRole";
import DealerOperatorRole from "layouts/DealerOperatorRole";

import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import "./App.css";
import mavricTheme from "assets/mavric-theme";
import SsoCallback from "layouts/SsoCallback.js";

const IndexPage = () => (
  <>
    <Typography variant="h3">Welcome to wohler</Typography>
    <Divider style={{ marginTop: 10, marginBottom: 10 }} />
    <Typography variant="h6">Feel free to take a look around</Typography>
  </>
);

function DebugPage(props) {

  useEffect(() => {
    console.log("Debug Page : ", props);
  }, []);
  return <> </>;

}

export default function App() {

  useEffect(() => {

    (function () {
      const state = { ...store.getState() };

      const UserId = parseInt(state.userid);
      const CustomerId = parseInt(state.customerId);
      const RoleId = parseInt(state.roleId);
      const AccessToken = state.accessToken;

      const queryParams = {
        // "customer_id": parseInt(CustomerId),
        "user_id": parseInt(UserId),
        "access_token": AccessToken,
        "role_id": parseInt(RoleId)
      };

      if (UserId) {
        axios.defaults.headers.common['data'] = JSON.stringify(queryParams);
      } else {
        axios.defaults.headers.common['data'] = null;
      }
    })();

  }, []);



  const state = { ...store.getState() };

  const UserId = parseInt(state.userid);
  // const CustomerId = parseInt(state.customerId);
  const RoleId = parseInt(state.roleId);
  const AccessToken = state.accessToken;
  const isAuthUser = state.isAuthUser;
  const myRole = state.role;

  const isAdmin = (myRole === "admin") ? true : false;
  const isOperator = (myRole === "operator") ? true : false;
  const isManager = (myRole === "manager") ? true : false;
  // const MyStateRole = useSelector(state => state.role);
  const isAccounting = (myRole === "accounting") ? true : false;
  const isSupport = (myRole === "support") ? true : false;
  const isSalesOperator = (myRole === "salesoperator") ? true : false;
  const isSalesAdmin = (myRole === "salesadmin") ? true : false;
  const isDealerAdmin = (myRole === "dealeradmin") ? true : false;
  const isDealerOperator = (myRole === "dealeroperator") ? true : false;
  const history = useHistory();
  // const navigation = useNavigate();


  function getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");

      /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
      if (name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
      }
    }

    // Return null if not found
    return null;
  }


  var authToken = getCookie("token");
  console.log("URL called in App.js : ", window.location.pathname, " UserId : ", UserId);

  const strURL = window.location.pathname;
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');


  return (
    <>
      <Provider store={store}>
        {/*<Provider /> component from the react-redux library to make the global redux store available throughout the application. */}
        <ThemeProvider theme={mavricTheme}>
          <CssBaseline />
          <Router>
            <AuthRoute path="/ssoCallback" component={SsoCallback} type="guest" />
            <AuthRoute path="/support" component={Support} type="support" />
            <AuthRoute path="/accounting" component={Accounting} type="accounting" />
            <AuthRoute path="/salesoperator" component={SalesOpeartor} type="salesoperator" />
            <AuthRoute path="/salesadmin" component={SalesAdmin} type="salesadmin" />
            <AuthRoute path="/dealeradmin" component={DealerAdminRole} type="dealeradmin" />
            <AuthRoute path="/dealeroperator" component={DealerOperatorRole} type="dealeroperator" />
            {/* <AuthRoute path="/debug" component={DebugPage} type="guest" /> */}
            {/* <AuthRoute path="/customers" component={CustomerView} type="guest" />
            <AuthRoute path="/licenses" component={LicensesView} type="guest" />
            <AuthRoute path="/dataconsumption" component={DataConsumptionView} type="guest" /> */}
            {/* <AuthRoute path="/apps" component={LandingApps} type="guest" /> */}
            <AuthRoute path="/login" component={LoginPage} type="guest" />
            <Switch>
              {
                (!authToken && strURL !== "/ssoCallback") 
                ? ( <Redirect from="/" to="/login" /> ) 
                : (
                  strURL === "/" ? (
                    <Redirect
                      from="/"
                      to={isAccounting ? "/accounting/customers/list"
                          : isSalesAdmin ? "/salesadmin/customers/list"
                            : isSalesOperator ? "/salesoperator/customers/list"
                              : isSupport  ? "/support/customers/list"
                                : isDealerAdmin ? "/dealeradmin/customers/list"
                                  : isDealerOperator ? "/dealeroperator/customers/list"
                                : "/login"
                      }
                    />
                  ) : (
                    <Redirect from="/" to={strURL} />
                  )
                )
              }
            </Switch>

            {/* <Switch>
                {
                  (!authToken)
                    ? (<Redirect from="/" to="/login" />)
                    : ((strURL === "/") ? (<Redirect from="/" to="/apps" />) : (<Redirect from="/" to={strURL} />))
                }
              </Switch> */}

          </Router>
        </ThemeProvider>
      </Provider>
    </>
  );

}
